<template>

  <div class="hflex">

    <div class="hflex-col-0 search-filters">

      <button 
        v-if="isMobile"
        class="btn btn-secondary btn-block"
        @click="expand">
        Exibir filtros
        </button>

      <filters 
        v-show="show || !isMobile"
        :initFilters="initFilters"
        :models="models"
        @changed="changed">
        </filters>

    </div>
    <div class="hflex-col-1">

      <div class="vflex">
        <div
          v-if="$slots.header"
          class="vflex-row-0 vflex-header">
          <slot name="header"></slot>
        </div>
        <div class="vflex-row-1">
          <slot></slot>
        </div>
        <div
          v-if="$slots.footer"
          class="vflex-row-0 vflex-footer">
          <slot name="footer"></slot>
        </div>
      </div>

    </div>

  </div>

</template>

<script>
import Filters from './Filters'

export default {
  name: 'Filtery',
  components: {
    Filters
  },
  props: {
    'models': {
      type: Array,
      default: () => { return [] }
    },
    'initFilters': {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      windowWidth: 0,
      show: false
    }
  },
  mounted () {
    const resize = () => {
      this.windowWidth = window.innerWidth
    }

    this.$nextTick(() => {
      window.addEventListener('resize', resize)
      resize()
    })
  },
  computed: {
    isMobile () {
      return this.windowWidth <= 700
    }
  },
  methods: {
    changed (filters) {
      this.$emit('changed', filters)
    },
    expand () {
      this.show = !this.show
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.search-filters{
  min-width: 260px;
  background: rgba(0,0,0,0.1);
  padding: 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Filterfy/Filterfy.vue